import type { TourConfig } from "~/features/onboarding/types/tour-config";

export const helpCenterTourConfig: TourConfig = {
    id: "help-center-callout",
    page: "*",

    welcome: {
        title: "Find answers here",
        description: "Open the Help Center from the navigation.",
        startButtonText: "Show me",
        skipButtonText: "Skip",
    },

    steps: [
        {
            id: "help-center-nav",
            targetSelector: "[data-tour-id='help-center-nav']",
            title: "Find answers here",
            content:
                "Open the Help Center any time from here - guides, FAQs, and how-tos.",
            position: "right",
            disableBackdropClose: true,
            finishButtonText: "Visit",
            finishHref: "/help",
        },
    ],
};
